export default __webpack_public_path__ + "static/media/hero-mobile.6967c22f.png";